module.exports = __webpack_public_path__ + "img/privilege.5e2a390.png";